export default __webpack_public_path__ + "static/media/7.ed59e23b.jpg";